import React, { useState } from "react";
import CustomBtn from "components/fragments/CustomBtn";
import CouponCard from "components/fragments/CouponCard";
import ticket_expired from "img/ticket_expired.png";

export default function PromotionDiscount({
  setPaymentSelect,
  orderPrice,
  setPaymentObj,
  promotionDiscountObj,
}) {
  const [couponSelected, setCouponSelected] = useState(null);
  const [couponList, setCouponList] = useState([]);

  const handleConfirmPromotion = async () => {
    if (!couponSelected) return;
    promotionDiscountObj.setPromotionDiscount(couponSelected);
    await setPaymentSelect((prev) => ({
      ...prev,
      paymentChannelID: 0,
    }));
  };

  return (
    <>
      <div className="font-light text-[16px] mb-2">กรุณาเลือกโปรโมชั่น</div>

      <div>
        {couponList.length > 0 ? (
          <div className="bg-[#F4F4F4] p-2 rounded-lg h-[calc(100vh-175px)] overflow-auto">
            {couponList.map((item) => (
              <div className="mb-2" key={item.id}>
                <CouponCard
                  selected={couponSelected && item.id === couponSelected.id}
                  item={item}
                  handleOnClick={() => setCouponSelected(item)}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-[#FFF] p-2 rounded-lg h-[calc(100vh-355px)] flex items-center justify-center overflow-auto">
            <div className="text-center">
              <img
                src={ticket_expired}
                className="mx-auto"
                alt="No promotions available"
              />
              <div className="text-center">ไม่พบคูปองที่เข้าเงื่อนไข !</div>
            </div>
          </div>
        )}
      </div>

      <div className="ml-auto text-right mt-3">
        <CustomBtn
          className="leading-[0.8] w-fit min-w-[min(12.66vw,129.6px)] text-18 text-white font-[700] min-h-[min(5.47vw,56px)] rounded-[min(0.39vw,4px)] btn-main-active"
          btntxt="ยืนยันโปรโมชั่น"
          disabled={!couponSelected}
          onClick={handleConfirmPromotion}
        />
      </div>
    </>
  );
}
